/**
Copyright (C) 2022 by SeQuenX  - All Rights Reserved
This file is part of the ComplyVantage product development,
and is released under the "Commercial License Agreement".
You should have received a copy of the Commercial License Agreement license with
this file. If not, please write to: legal@sequenx.com, or visit www.sequenx.com
*/
import React from "react";
import { motion } from "framer-motion";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineDot from "@mui/lab/TimelineDot";
import { MdLaptopMac } from "react-icons/md";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

const timelineData = [
  {
    year: "2024",
    content: [
      "New Recruitment Partnerships",
      "Launched ComplyVantage ",
      "Revenue > EUR 4 Million",
    ],
  },
  {
    year: "2023",
    content: [
      "Launched Netherlands Pakistan Technology Corridor (NPTC)",
      "MOU with COMSATS & New Office Pakistan",
      "Revenue > EUR 4 Million",
    ],
  },
  {
    year: "2022",
    content: [
      "Hybrid Work Model Implemented",
      "Services Expansion Pakistan",
      "Revenue > EUR 3 Million",
    ],
  },
  {
    year: "2021",
    content: [
      "Services Expansion India",
      "Revenue > EUR 2.5 Million",
      "Expansion of Recruitment Outreach",
    ],
  },
  {
    year: "2020",
    content: [
      "Recruitment Division Setup",
      "Full Remote Deployment COVID-19",
      "Revenue > EUR 2 Million",
    ],
  },
  {
    year: "2019",
    content: [
      "Professional Consulting & (International Placements)",
      "Revenue > EUR 1.5 Million",
      "Expansion of Resource Pool -Code, Deployment, Testing Services",
    ],
  },
  {
    year: "2018",
    content: [
      "Services Expansion into USA",
      "Talent Management & SkillPool Development",
      "Revenue crosses EUR 1 Million",
    ],
  },
  {
    year: "2017",
    content: [
      "Services Expansion: Western Europe",
      "IND Recognized Sponsorship",
      "Revenue > EUR 500K",
    ],
  },
  {
    year: "2016",
    content: ["Founded in August 2016", "Marketing Engagements & Branding"],
  },
];

const OurGrowthStory = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-800 mb-4 ">
            {t("aboutUs.storyTitle")}
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
          className="w-full"
        >
          <Timeline position="alternate" sx={{ padding: 0 }}>
            {timelineData.map((item, index) => (
              <TimelineItem key={index}>
                <TimelineOppositeContent
                  sx={{
                    m: "auto 0",
                    color: "text.secondary",
                    fontWeight: "bold",
                    fontSize: "1.2rem",
                  }}
                  align="right"
                  variant="body2"
                >
                  {item.year}
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineConnector sx={{ bgcolor: "primary.main" }} />
                  <TimelineDot
                    color="primary"
                    variant="outlined"
                    sx={{
                      borderColor: "primary.main",
                      borderWidth: 2,
                      boxShadow: "0 0 0 4px rgba(66, 153, 225, 0.1)",
                    }}
                  >
                    <MdLaptopMac className="text-blue-600" />
                  </TimelineDot>
                  <TimelineConnector sx={{ bgcolor: "primary.main" }} />
                </TimelineSeparator>
                <TimelineContent sx={{ py: "12px", px: 2 }}>
                  {item.content.map((text, idx) => (
                    <motion.div
                      key={idx}
                      initial={{ opacity: 0, x: -20 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.4, delay: idx * 0.1 }}
                      viewport={{ once: true }}
                    >
                      <Typography
                        sx={{
                          py: "8px",
                          px: "16px",
                          mb: "8px",
                          fontSize: "1.1rem",
                          fontWeight: "500",
                          borderRadius: "8px",
                          backgroundColor: "rgba(66, 153, 225, 0.1)",
                          color: "text.primary",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            backgroundColor: "rgba(66, 153, 225, 0.2)",
                            transform: "translateX(5px)",
                          },
                        }}
                      >
                        {text}
                      </Typography>
                    </motion.div>
                  ))}
                </TimelineContent>
              </TimelineItem>
            ))}
          </Timeline>
        </motion.div>
      </div>
    </section>
  );
};

export default OurGrowthStory;
